import React, { Component } from "react";
import Card from "Utils/Cards/Card";
import TabBar from "rc-tabs/lib/TabBar";
import TabContent from "rc-tabs/lib/TabContent";
import Tabs, { TabPane } from "rc-tabs";
import { ResumenCierresTab } from "./tabs/ResumenCierresTab";
import { CierresMensualesInventarioTab } from "./tabs/CierresMensualesInventarioTab";
import "./styles/ReporteInventarios.css";
import "../../components/Existencia/styles/Existencia.css";

class ReporteInventarios extends Component {
    constructor(props) {
        super(props);

        const params = new URLSearchParams(props.location.search);
        let tabFromUrl = params.get("tab");

        // significa que fue carga nueva, por lo tanto no se conserva el estado anterior de filtros y página
        if (!tabFromUrl) {
            tabFromUrl = "RESUMEN_CIERRES";

            params.set("tab", tabFromUrl);

            this.props.history.replace({
                search: params.toString(),
            });

            sessionStorage.removeItem("resumen_cierres_inventario");
            sessionStorage.removeItem("cierres_mensuales_inventario");
        }

        this.state = {
            tab: tabFromUrl,
        };
    }

    handleChangeTab = (tab) => {
        this.setState({ tab });

        const params = new URLSearchParams(this.props.location.search);
        params.set("tab", tab);

        this.props.history.replace({
            search: params.toString(),
        });
    };

    render() {
        return (
            <div
                className="mb-4 col-12"
                style={{ maxWidth: "90vw", margin: "auto" }}
            >
                <Card
                    icon="inventario_activo"
                    titulo="REPORTE DE INVENTARIOS"
                    subtitulo=""
                    noBorder
                >
                    <Tabs
                        activeKey={this.state.tab}
                        tabBarPosition="top"
                        onChange={this.handleChangeTab}
                        renderTabBar={() => <TabBar />}
                        renderTabContent={() => <TabContent animated={false} />}
                    >
                        <TabPane tab="Resumen de cierres" key="RESUMEN_CIERRES">
                            <ResumenCierresTab />
                        </TabPane>

                        <TabPane
                            tab="Cierres mensuales inventario"
                            key="CIERRES_MENSUALES"
                        >
                            <CierresMensualesInventarioTab />
                        </TabPane>
                    </Tabs>
                </Card>
            </div>
        );
    }
}

export default ReporteInventarios;
